"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_DATA = {
    configuration: {},
    version: "0.0.0"
};
var WorkspaceWindow = /** @class */ (function () {
    function WorkspaceWindow(_serverModel) {
        this._serverModel = _serverModel;
    }
    WorkspaceWindow.prototype.getId = function () {
        return this._serverModel.id;
    };
    WorkspaceWindow.prototype.setId = function (id) {
        this._serverModel.id = id;
    };
    WorkspaceWindow.prototype.getName = function () {
        return this._serverModel.name;
    };
    WorkspaceWindow.prototype.getWorkspaceId = function () {
        return this._serverModel.workspaceId;
    };
    WorkspaceWindow.prototype.setWorkspaceId = function (workspaceId) {
        this._serverModel.workspaceId = workspaceId;
    };
    WorkspaceWindow.prototype.getWorkspaceName = function () {
        return this._serverModel.workspaceName;
    };
    WorkspaceWindow.prototype.setWorkspaceName = function (workspaceName) {
        this._serverModel.workspaceName = workspaceName;
    };
    WorkspaceWindow.prototype.getLayout = function () {
        return this._serverModel.layout;
    };
    WorkspaceWindow.prototype.setLayout = function (layout) {
        this._serverModel.layout = layout;
    };
    WorkspaceWindow.prototype.getData = function () {
        if (this._serverModel.contents && this._serverModel.contents.data) {
            return JSON.parse(this._serverModel.contents.data);
        }
        else {
            return DEFAULT_DATA;
        }
    };
    WorkspaceWindow.prototype.setData = function (data) {
        if (!this._serverModel.contents) {
            this._serverModel.contents = {};
        }
        this._serverModel.contents.data = JSON.stringify(data);
    };
    WorkspaceWindow.prototype.isDataEmpty = function () {
        return !this.getData() || !Object.keys(this.getData().configuration).length;
    };
    WorkspaceWindow.prototype.getConfigurationProperty = function (key) {
        return this.getData().configuration[key];
    };
    WorkspaceWindow.prototype.setConfigurationProperty = function (key, value) {
        var data = this.getData();
        data.configuration[key] = value;
        this.setData(data);
    };
    WorkspaceWindow.prototype.isNewWindow = function () {
        return this._serverModel.isNewWindow;
    };
    WorkspaceWindow.prototype.serverModel = function () {
        return this._serverModel;
    };
    return WorkspaceWindow;
}());
exports.WorkspaceWindow = WorkspaceWindow;



//////////////////
// WEBPACK FOOTER
// /app/~/redi-workspaces-web-lib/dist/business/workspace-window.js
// module id = 137
// module chunks = 0